import { Autocomplete, TextField } from '@mui/material';
import { useVocab, type VocabKind } from '../../api/queries/vocab';

interface VocabAutocompleteProps {
  kind: VocabKind;
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  label: string;
  size?: 'small' | 'medium';
}

export function VocabAutocomplete({
  kind,
  value,
  onChange,
  label,
  size = 'small',
}: VocabAutocompleteProps) {
  const { data: entries = [] } = useVocab(kind);
  const options = entries.map((e) => e.label);

  return (
    <Autocomplete
      freeSolo
      size={size}
      options={options}
      value={value ?? ''}
      onChange={(_, newValue) => onChange(newValue || null)}
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') onChange(newValue || null);
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}
